export const ELEMENT_RULE = "rule";
// export const ELEMENT_LABEL = "label";
export const ELEMENT_CONDITION = "condition";
export const ELEMENT_CONCLUSION = "conclusion";
export const ELEMENT_NOTE = "note";
export const ELEMENT_OPERATOR = "operator";
export const ELEMENT_BANNER = "banner";
export const ELEMENT_TABLE = "table";
